import { useAct } from 'FlowBuilder/store'
import SharedModal from 'Shared/components/Modal/Modal'
import AddQuestion from './AddQuestion'
import EditContent from './EditContent'
import AddAction from './AddAction'
import EditActionTemplate from './EditActionTemplate'
import EditDecisionMakerSet from './EditDecisionMakerSet'
import FilterDecisionMakerSet from './FilterDecisionMakerSet'
import { clientLanguagesData } from 'Shared/TranslatableTextContent/clientLanguagesData'

export default function Modal() {
  const act = useAct()
  const { kind, language } = useSel(s => s.local.modal)

  const clientLanguages = clientLanguagesData()
  const flag = (language && Object.keys(clientLanguages).length > 1) ? clientLanguages[language]?.flag || '' : ''

  function title(kind) {
    switch (kind) {
      case 'addQuestion':
        return 'Add a question';
      case 'editContent':
        return flag ? `${flag} Edit content` : 'Edit content';
      case 'addAction':
        return 'Add step to journey';
      case 'editTemplate':
        return 'Edit template';
      case 'editDecisionMakerSet':
        return 'Edit recipients';
      case 'filterDecisionMakerSet':
        return 'Filter recipients';
      default:
        return ''; // or some default value
    }
  }

  return <SharedModal open={true} title={title(kind)} autoHeight onCancel={act.local.closeModal}>
    {kind === 'addQuestion' && <AddQuestion />}
    {kind === 'editContent' && <EditContent />}
    {kind === 'addAction' && <AddAction />}
    {kind === 'editTemplate' && <EditActionTemplate />}
    {kind === 'editDecisionMakerSet' && <EditDecisionMakerSet />}
    {kind === 'filterDecisionMakerSet' && <FilterDecisionMakerSet />}
  </SharedModal>
}
